import { isAccountFeatureEnabled } from "owa-feature-flags";
import type { MailboxInfo } from "owa-client-types";

/**
 * Single source of truth for whether the Drafts "meaningful save time" feature is on for
 * the given account. This client flight is the only gate that decides whether consumers
 * (sort, display, group headers, reposition) use LastMeaningfulDraftSaveTime. Keeping the
 * flight name in one place stops those paths from ever disagreeing on whether the property
 * is in play. Note the property is not guaranteed present on every draft — older drafts that
 * predate the feature can lack it, and consumers fall back to LastModifiedTime in that case.
 */
export function isDraftsMeaningfulSaveTimeEnabled(mailboxInfo: MailboxInfo | undefined): boolean {
    return !!mailboxInfo && isAccountFeatureEnabled("tri-draftsMeaningfulSaveTime", mailboxInfo);
}
